module.exports = __webpack_public_path__ + "img/nathan.a49b8359.png";